import colors from '../colors';

const boxScrollBarStyle = {
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '100%',
    background: colors.LOW_CONTRAST_GRAY
  },
  '&::-webkit-scrollbar-thumb': {
    background: colors.MEDIUM_GREY,
    borderRadius: '5px'
  }
};

export default boxScrollBarStyle;
